import { Component, OnInit } from '@angular/core';
import { CmsService } from 'src/app/core/cms.service';
import { LanguageService } from 'src/app/core/language.service';
import { SiteSettingsMap } from 'src/app/core/cms.models';

@Component({
  selector: 'app-footer1',
  templateUrl: './footer1.component.html',
  styleUrls: ['./footer1.component.css']
})
export class Footer1Component implements OnInit {
  s: SiteSettingsMap = {};
  readonly year = new Date().getFullYear();

  /** Newsletter signup state. */
  nlEmail = '';
  nlWebsite = '';   // honeypot — real users leave this empty
  nlSending = false;
  nlDone = false;
  nlError = '';

  constructor(private cms: CmsService, public lang: LanguageService) {}

  ngOnInit(): void {
    this.cms.getSettings().subscribe({
      next: (map) => { this.s = map || {}; },
      error: () => { /* keep static fallbacks if settings can't load */ }
    });
  }

  /** Submits the footer newsletter signup to the dedicated subscribe endpoint. */
  subscribe(): void {
    this.nlError = '';
    const email = this.nlEmail.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      this.nlError = this.lang.isArabic ? 'يرجى إدخال بريد إلكتروني صحيح.' : 'Please enter a valid email address.';
      return;
    }
    this.nlSending = true;
    this.cms.subscribe(email, 'footer', this.nlWebsite).subscribe({
      next: () => { this.nlSending = false; this.nlDone = true; this.nlEmail = ''; },
      error: (err) => {
        this.nlSending = false;
        if (err?.status === 429) {
          const secs = err?.error?.retryAfterSeconds;
          this.nlError = this.lang.isArabic
            ? `محاولات كثيرة. حاول مرة أخرى بعد ${secs ? secs + ' ثانية' : 'قليل'}.`
            : `Too many attempts. Try again ${secs ? 'in ' + secs + ' seconds' : 'shortly'}.`;
          return;
        }
        this.nlError = this.lang.isArabic ? 'تعذّر الاشتراك. حاول مرة أخرى.' : 'Could not subscribe. Please try again.';
      }
    });
  }

  /** Returns the setting value, or the provided fallback if missing/empty. */
  get(key: string, fallback = ''): string {
    const v = this.s[key];
    return v && v.trim().length ? v : fallback;
  }

  /** Localized address (falls back EN<->AR). */
  address(fallback = ''): string {
    const ar = this.s['contact.addressAr'];
    const en = this.s['contact.addressEn'];
    if (this.lang.isArabic) return (ar && ar.trim() ? ar : en) || fallback;
    return (en && en.trim() ? en : ar) || fallback;
  }
}